import { Button, DialogActions, DialogContent, DialogTitle, Grid } from "@mui/material";
import { createListStore } from "../../common/listStore";
import { renderListStore } from "../../common/listStoreUi";
import { renderClose } from "../../common/dialog";
import { useState } from "react";
import { CustomerDto, newReturn, ReturnEditDto, ReturnInvoiceDto } from "./types";
import { createEntityStore, UseEntityStore } from "../../common/entityStore";
import { propDateField, propNumberField, propTextField } from "../../common/entityStoreForm";
import { propRequired } from "../../common/entityStoreValidators";
import { customerDialogTitle, useCustomerBasicInfo } from "./common";
import { UserTypeId, useAccountStore } from "../../common/account";
import { useInvoiceStates } from "../../common/enum";

export const ReturnDialog = (props: {
    close: () => void;
    useCustomerStore: UseEntityStore<CustomerDto>;
    onReturnCreated(): void;
}) => {
    const { userTypeId } = useAccountStore(p => ({ userTypeId: p.data?.accessTokenDecoded.userTypeId }));
    const customer = useCustomerBasicInfo(props.useCustomerStore);
    const [{ useReturnStore, useInvoiceListStore }] = useState(() => {
        const useReturnStore = createEntityStore<ReturnEditDto>({
            data: newReturn(), path: "customers/returns", id: null,
            saveProps: ["invcId", "retDte", "orderShipmentId"],
            onCreated() {
                props.onReturnCreated();
                props.close();
            },
            propValidators: [
                propRequired("invcId", "Select invoice on right side."),
                propRequired("retAmt"),
                propRequired("retDte"),
            ]
        });
        const useInvoiceListStore = createListStore<ReturnInvoiceDto>({
            path: `customers/returns/getInvoices?customerId=${customer.id}`, getId: p => JSON.stringify(p), listProps: [
                { column: "invcDte", label: "Invoice date", width: 120, type: "date" },
                { column: "invcId", label: "Invoice number", width: 120 },
                { column: "invcAmt", label: "Return amount", width: 120, type: "currency" },
                { column: "invoiceStateId", label: "Invoice status", flex: 1, enumStore: useInvoiceStates },
            ]
        });
        useInvoiceListStore.getState().selectedItem$.subscribe({
            next(item) {
                useReturnStore.getState().setClientDataProp("invcId", item ? item.invcId : "");
                useReturnStore.getState().setClientDataProp("orderShipmentId", item ? item.orderShipmentId : null);
                if (item) {
                    useReturnStore.getState().setClientDataProp("retAmt", item.invcAmt);
                    useReturnStore.getState().setClientDataProp("retAmtFormatted", undefined);
                }
            },
        });
        return { useReturnStore, useInvoiceListStore };
    });
    const { save, isSaveDisabled } = useReturnStore(p => ({ save: p.save, isSaveDisabled: p.isSaveDisabled }));
    return <>
        <DialogTitle>{customerDialogTitle("New return", customer)}</DialogTitle>
        {renderClose(props.close)}
        <DialogContent>
            <Grid container columnSpacing={4} alignItems="stretch">
                <Grid container item xs={3} columnSpacing={2} alignSelf="flex-start">
                    <Grid item xs={12}>{propDateField(useReturnStore)("retDte", "retDteFormatted", "Return date", { disabled: userTypeId !== UserTypeId.Admin })}</Grid>
                    <Grid item xs={12}>{propTextField(useReturnStore)("invcId", "Invoice number", { disabled: true })}</Grid>
                    <Grid item xs={12}>{propNumberField(useReturnStore)("retAmt", "retAmtFormatted", "Return amount", { isCurrency: true, disabled: true })}</Grid>
                </Grid>
                <Grid container item xs={9}>
                    {renderListStore(useInvoiceListStore)}
                </Grid>
            </Grid>
        </DialogContent>
        <DialogActions>
            <Button disabled={isSaveDisabled} onClick={save} color="save">Save</Button>
            <Button onClick={props.close} color="negative" variant="outlined">Close</Button>
        </DialogActions>
    </>;
};
